<template>
    <div class="body">
        <div class="login-content">
            <div class="logo-holder">
                <img class="logo" src="/assets/logo-actic-black.svg" />
            </div>

            <div v-if="showSelectModal">
                <div class="login-item login-item-clp" @click="loadCLP()">
                    <div>
                        <i class="material-icons-outlined color-blue">call</i>
                    </div>
                    <div>
                        <h2>Curated Leads Portal</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>
                    <div>
                        <i class="material-icons-outlined color-blue">arrow_forward_ios</i>
                    </div>
                </div>

                <div class="login-item" @click="loadSales()">
                    <div>
                        <i class="material-icons-outlined color-blue">add_shopping_cart</i>
                    </div>
                    <div>
                        <h2>Sales Portal</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>
                    <div>
                        <i class="material-icons-outlined color-blue">arrow_forward_ios</i>
                    </div>
                </div>

            </div>


            <form v-if="!showSelectModal" @submit.prevent="login()">
                <h1>Actic Sälj</h1>
                <p>Ange dina uppgifter för att logga in</p>
                <input
                    v-model="username"
                    type="text"
                    placeholder="Användarnamn"
                />
                <input
                    v-model="password"
                    type="password"
                    placeholder="Lösenord"
                />
                <button type="submit" class="button" :disabled="loading">
                    <span v-if="!loading">Logga in</span>
                    <span v-if="loading">
                        <div class="lds-ellipsis">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </span>
                </button>
                <div class="message-error" v-if="loginError">
                    {{ loginError }}
                </div>
            </form>
            <div></div>
        </div>
        <div class="modal-holder" v-if="showCenterModal">
            <div class="login-modal">
                <h2>Välj center</h2>
                <p>Välj det center som du vill logga in på.</p>

                <ul>
                    <li v-for="center in centers" :key="center.id">
                        <div
                            class="center-select-button"
                            @click="selectCenter(center)"
                        >
                            {{ center.name }}
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="loadingRedirect" class="loading">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            username: "",
            password: "",
            loading: false,
            loginError: false,
            centers: [],
            showCenterModal: false,
            userInfo: false,
            loadingRedirect: false,
            showSelectModal: false
        };
    },
    methods: {
        selectCenter(center) {
            this.loadingRedirect = true;
            this.userInfo.current_center = center;
            this.loginSuccessfull();
        },
        loginSuccessfull() {

            // Show select modal
            localStorage.setItem("user", JSON.stringify(this.userInfo));
            this.showCenterModal = false;
            this.showSelectModal = true;
            this.loadingRedirect = false;
            console.log(this.userInfo);
        },
        loadCLP() {
            this.loading = true;
            window.location.href = "/app/clp";
        },
        loadSales() {
            this.loading = true;
            window.location.href = "/app/sales";
        },
        login() {
            this.loading = true;
            this.loginError = false;
            let self = this;
            // Try to login the user and get a token
            axios
                .post("/api/auth/login", {
                    username: this.username,
                    password: this.password,
                })
                .then((response) => {
                    // Save the token in the local storage
                    this.userInfo = response.data.user;

                    localStorage.setItem(
                        "token",
                        response.data.token.access_token
                    );

                    if (response.data.user.current_center) {
                        // Just one center or user have select a favorite center, redirect to the center
                        self.loginSuccessfull();
                    } else {
                        // More than one center, shpw select
                        self.centers = response.data.user.centers;
                        self.showCenterModal = true;
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    //this.loginError = response.data.error_message;
                    if (error.response.data.error_message !== undefined) {
                        this.loginError = error.response.data.error_message;
                        return;
                    }
                    this.loginError =
                        "Ingen kontakt med servern. Försök igen senare.";
                });
        },
    },
};
</script>

<style scoped>
h1 {
    font-size: 34px;
    line-height: 44px;
    letter-spacing: -1px;

    @media (min-width: 500px) {
        font-size: 50px;
        line-height: 60px;
        margin-bottom: 10px;
    }
}

p {
    font-size: 16px;
    line-height: 25px;
    letter-spacing: 1px;
    font-family: "helvetica-light";
    font-weight: 300;
}

.body {
    background-color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo-holder {
    height: 44px;
    border-bottom: 1px solid #d9d8d6;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    @media (min-width: 500px) {
        height: 80px;
        border-bottom: unset;
    }
}

.logo {
    width: 95px;
    height: auto;
    margin-right: 0;
}

.login-holder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.login-content {
    height: 100%;
    width: 100%;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;

    p {
        text-align: center;
    }
}

.login-modal {
    max-width: 300px;
    background-color: #fff;
    border: 1px solid #617594;
    padding: 25px;
    max-width: calc(100% - 40px);
    position: relative;

    p {
        margin-bottom: 16px;
    }

    ul {
        max-height: 400px;
        overflow-y: auto;
    }

    .center-select-button {
        background-color: #617594;
        color: #fff;
        padding: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        border-radius: 5px;
        text-align: center;
    }
}

.loader {
    font-size: 14px;
    animation: spin 0.8s linear infinite;
}

.button {
    width: 100%;
    margin-top: auto;
    margin-bottom: 30px;
    padding: 18px 20px;
    font-family: "hansen-grotesque-bold", sans-serif;
    font-size: 18px;

    @media (min-width: 500px) {
        width: 300px;
        margin-top: 40px;
        margin-bottom: 20px;
        padding: 21px 20px;
    }
}

p {
    margin-bottom: 50px;

    @media (min-width: 500px) {
        margin-bottom: 70px;
    }
}

form {
    max-width: 650px;
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 110px 20px 20px 20px;

    @media (min-width: 500px) {
        flex: unset;
        padding-top: 20px;
    }
}

.message-error {
    position: absolute;
    font-size: 14px;
    font-family: "helvetica-bold";
    font-weight: 700;
    letter-spacing: 1px;
    bottom: 130px;

    @media (min-width: 500px) {
        bottom: -10px;
        margin-top: 0;
    }
}

input[type="text"],
input[type="password"] {
    margin-bottom: 20px;
}

@keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

.login-item {
    display: flex;
    border: 1px solid #ededed;
    padding: 20px;
    max-width: 670px;
    width: calc(100% - 40px);
    align-items: center;
    box-shadow: 0px 10px 30px 0px #00000014;
    cursor: pointer;
    margin: 0 auto;
    transition: all 0.3s ease;

    &:hover {
        background-color: #f7f7f7;
        transition: all 0.3s ease;
    }

    h2 {
        margin-bottom: 10px;
    }

    i {
        font-size: 52px;
    }

    p {
        text-align: left;
        font-size: 15px;
        line-height: 22px;
        color: #617594;
        margin-bottom: 0;
    }


    div:first-child {
        margin-right: 20px;
        display: none;

        @media (min-width: 380px) {
            display: block;
        }
    }

    div:last-child {
        margin-left: 30px;

        i {
            margin-right: -12px;
            font-size: 28px;
        }
    }
}

.login-item-clp {
    margin-bottom: 52px;
}

</style>
